module.exports = __webpack_public_path__ + "img/news2_3.1a261d14.png";